<script>
export default {
  name: 'BookingCardCandidate',
  props: {
    id: {
      type: Number,
      required: true,
    },
    firstName: {
      type: String,
      default: null,
    },
    lastName: {
      type: String,
      default: null,
    },
    defaultName: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <h4>
    <a
      style="min-width: 172px;"
      :class="['title', id <= 0 ? 'inactivelink' : '']"
      @click="$emit('click')"
    >
      {{ id > 0 ? firstName + ' ' + lastName : defaultName }}
    </a>
  </h4>
</template>

<style lang="scss" scoped>
.inactivelink {
  pointer-events: none;
  cursor: default;
}
</style>
